import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "../layout";
import Home from "../pages/home/home";
import Registration from "../pages/quiz/quiz";
import Terms from "../pages/termsServices/terms";

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Navigate to="/" replace />} />
        <Route path="/quiz/:slug" element={<Registration />} />
        <Route path="/Terms_Services" element={<Terms />} />
      </Route>
    </Routes>
  );
}